import { h, render } from 'preact';
import { delay } from './election-utils';

// just in case this gets removed
window.ttData = window.ttData || {};

// open links in a new tab
document.addEventListener('click', e => {
  const link = e.target.closest && e.target.closest('a[href]');
  if (!link || link.target) return;

  const href = link.getAttribute('href');
  if (href.startsWith('#') || /^(mailto|tel|javascript):/i.test(href)) return;

  link.target = '_blank';
  link.rel = 'noopener';
});

// related content
const relatedContentContainer = document.getElementById(
  'related-content-container'
);

if (relatedContentContainer && window.ttData.related_category) {
  import(
    /* webpackChunkName: "RelatedContent" */ './components/RelatedContent'
  ).then(({ default: RelatedContent }) =>
    render(
      <RelatedContent
        title={'Read more'}
        related_category={window.ttData.related_category}
      />,
      relatedContentContainer
    )
  );
}

import(/* webpackChunkName: "ads" */ './utils/ad-loader').then(
  ({ default: AdLoader }) => {
    delay(function() {
      const ads = new AdLoader();
      ads.init();
    }, 600); // end delay
  }
);
